import React from 'react';
import FAIcon from 'faIcon';
import HostActions from './HostPortalActions';
import Mailto from 'react-mailto';
import {Modal} from 'react-bootstrap';
import {TextField, SelectField} from 'form-fields';
import 'idempotent-babel-polyfill';
import HostPortalActions from './HostPortalActions';
import moment from 'moment';
import classnames from 'classnames';

export default class GuestsTabGridItem extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			showDropdown: false,
			showEditModal: false,
			EditGuest_GuestName: "",
			EditGuest_GuestEmailAddress: "",
			GuestStatusEdit: "",
			editStatusList: [],
			editHasChanged: false
		}
		moment.locale(window.jenkon.language)
	}

	showEditModal(showEditModal, EditGuest_GuestName, EditGuest_GuestEmailAddress, GuestStatusEdit) {
		this.setState({
			showEditModal,
			EditGuest_GuestName,
			EditGuest_GuestEmailAddress,
			GuestStatusEdit,
			editStatusList: this.createGuestStatusList(GuestStatusEdit),
			showDropdown: false,
			editHasChanged: false
		}, () => {
			if(showEditModal)
				this.validateEmail();
		});
	}

	validateEmail() {
		HostActions.validateGuestEdit({
			Name: this.state.EditGuest_GuestName,
			Email: this.state.EditGuest_GuestEmailAddress
		});
		return;
	}

	setStatus(key, code) {
		this.setState({
			GuestStatusEdit: code
		}, () => {
			this.hasChanged();
		})
	}

	changeField(name, value) {
		var diff = {};
		diff[name] = value;
		this.setState(diff, () => {
			this.hasChanged();
		});
	}

	deleteGuest(code) {
		this.setState({showDropdown: false});
		let message = this.props.resources["PWS.MyAccount.GuestsTabConfirmDelete"].replace("{0}", this.props.guest.name);
		let confirmed = confirm(message)
		if(confirmed) {
			let submitData = {
				EventCode: this.props.selectedEventDetails.code,
				GuestCode: this.props.guest.code
			}
			HostActions.deleteGuest(submitData)
		}
	}

	isValid() {
		return this.refs.GuestName_Edit.isValid() && this.refs.EmailAddress_Edit.isValid()
	}

	hasChanged() {
		if((this.state.EditGuest_GuestEmailAddress === this.props.guest.email && this.state.EditGuest_GuestName === this.props.guest.name && this.state.GuestStatusEdit === this.props.guest.status) || !this.isValid())
			this.setState({editHasChanged: false})
		else
			this.setState({editHasChanged: true})
	}

	updateGuest() {
		if(this.isValid() && this.props.validGuestEmail_edit) {
			let submitData = {
				EventCode: this.props.selectedEventDetails.code,
				GuestCode: this.props.guest.code,
				name: this.state.EditGuest_GuestName,
				Email: this.state.EditGuest_GuestEmailAddress,
				status: this.state.GuestStatusEdit,
			}
			let newDeclined = ['NEW', 'DCL'];
			HostActions.updateGuest(submitData);
			if(this.state.EditGuest_GuestEmailAddress !== this.props.guest.email && newDeclined.indexOf(this.state.GuestStatusEdit) === -1) {
				let message = this.props.resources["PWS.MyAccount.GuestsTabResendInvitationMessage"].replace("{0}", this.props.guest.name);
				let confirmed = confirm(message);
				if(confirmed)
					this.resentInvite(this.props.guest.code);
			}
			this.setState({
				showEditModal: false,
				showDropdown: false
			});
		}
	}

	resentInvite(code) {
		this.setState({showDropdown: false});
		this.sendInvite(true)
	}

	toggleDropdown() {
		this.setState({
			showDropdown: !this.state.showDropdown
		});
	}

	createDropdown() {
		let iconData = {
			Size: 14,
			Fill: "#666"
		};
		let newDeclined = ['NEW', 'DCL'];
		let sendReminder = !this.props.guest.optOut ? (
			<div className="dropdown-menu-item" onClick={this.sendReminder.bind(this)}>
				<FAIcon iconData={iconData} inline={true} name="bell" /> {this.props.resources['PWS.MyAccount.GuestsTabSendReminderLink']}
			</div>
		) : null;

		let deleteAction = (
			<div onClick={this.deleteGuest.bind(this)}>
				<div className="simpleHR"></div>
				<div className="dropdown-menu-item">
					<FAIcon iconData={iconData} inline={true} name="remove" /> {this.props.resources['PWS.MyAccount.GuestsTabDeleteGuestLink']}
				</div>
			</div>
		);
		let sendResendInvite = (newDeclined.indexOf(this.props.guest.status) === -1 && !this.props.guest.optOut) ? (
			<div className="dropdown-menu-item" onClick={this.sendInvite.bind(this, true)}>
				<FAIcon iconData={iconData} inline={true} name="envelope_o" /> {this.props.resources['PWS.MyAccount.GuestsTabResendInviteText']}
			</div>
		) : null
		return (
			<div className="dropdown-menu clearfix">
				<div onClick={this.toggleDropdown.bind(this)} className="blockBackground"></div>
				<div className="dropdown-menu-item" onClick={this.showEditModal.bind(this, true, this.props.guest.name, this.props.guest.email, this.props.guest.status)}>
					<FAIcon iconData={iconData} inline={true} name="pencil" /> {this.props.resources['PWS.MyAccount.GuestsTabEditGuestLink']}
				</div>
				{!this.props.guest.optout ? sendResendInvite : null}
				{newDeclined.indexOf(this.props.guest.status) > -1 ? null : sendReminder}
				{newDeclined.indexOf(this.props.guest.status) > -1 ? deleteAction : null}
			</div>
		);
	}

	sendReminder() {
		let sendData = {
			EventCode: this.props.selectedEventDetails.code,
			GuestCode: this.props.guest.code
		}
		HostPortalActions.sendReminder(sendData);
		this.setState({showDropdown: false});
	}

	sendInvite(isResend) {
		HostPortalActions.sendGuestInvite(this.props.selectedEventDetails.code, this.props.guest.code, isResend);
		this.setState({
			showDropdown: false
		});
	}

	displayStatus(){
		let returnValue = '';
		switch (this.props.guest.status) {
			case 'NEW':
				if (this.props.guest.optOut || (this.props.guest.email == null)) {
					returnValue = (
						<div className="guest-status">
							{this.props.resources[`PWS.MyAccount.AttendanceStatus${this.props.guest.status}`]}
							{remindedData}
						</div>
					);
				} else {
					returnValue = this.props.selectedEventDetails.eventStatus !== "Active" ? this.props.resources[`PWS.MyAccount.AttendanceStatus${this.props.guest.status}`] : (
						<div className="guest-status">
							<div className="send-invite-btn primary-btn" onClick={this.sendInvite.bind(this, false)} >
								<FAIcon  name="envelope_o" size={13} fill="#FFF" inline={true} />&nbsp;&nbsp;{this.props.resources['PWS.MyAccount.GuestsTabSendInviteText']}
							</div>
						</div>
					);
				}
				break;
			default:
				let remindedData = this.props.guest.reminderSent && this.props.guest.reminderSent != null ? (
					<div className="reminded">{`${this.props.resources["PWS.MyAccount.GuestsTabLastRemindedLabel"]}: ${moment(this.props.guest.reminderSent).format('ll')}`}</div>
				) : null;
				returnValue = (
					<div className="guest-status">
						{this.props.resources[`PWS.MyAccount.AttendanceStatus${this.props.guest.status}`]}
						{remindedData}
					</div>
				)
				break;
		}
		return returnValue;
	}

	createGuestStatusList(status) {
		let newStatusList = [];
		if(status === "ORD"){
			newStatusList = this.props.guestStatusList.filter(g => g.code === "ORD");
			newStatusList[0].description = this.props.resources[`PWS.MyAccount.AttendanceStatus${status}`];
		} else {
			let statusList = this.props.guestStatusList.filter(g => g.code !== "ORD" && g.code !== "REM");
			for( var l = 0; l < statusList.length; l++) {
				newStatusList.push({
					code: statusList[l].code,
					description: this.props.resources[`PWS.MyAccount.AttendanceStatus${statusList[l].code}`]
				});
			}
		}
		return newStatusList;
	}

	render() {
		let Rules = {
			GuestName: {
				required: true,
				requiredMessage: this.props.resources['PWS.MyAccount.GuestsTabGuestNameRequiredMessage']
			},
			EmailAddress: {
				required: this.props.selectedEventDetails.isVirtual,
				requiredMessage: this.props.resources['PWS.MyAccount.GuestsTabGuestEmailAddressRequiredMessage'],
				email: true,
				emailMessage: this.props.resources['PWS.MyAccount.GuestsTabGuestEmailAddressInvalidMessage']
			},
			Status: {
				required: true,
				requiredMessage: this.props.resources['PWS.MyAccount.GuestsTabGuestNameRequiredMessage']
			}
		}
		let Keys = {valueKey: 'code',nameKey: 'description'}
		let showHideActions = this.props.selectedEventDetails.eventStatus !== 'Active' ? null : (
			<div className={"guest-actions-icon dropdown-toggle " + (this.state.showDropdown ? 'pressed' : '')} aria-haspopup="true" aria-expanded="false">
				<FAIcon onClick={this.toggleDropdown.bind(this)} name="gear" size={20} fill="#666" iconStyle={{position: 'absolute', right: '25%', top: '25%'}}/>
				{this.state.showDropdown ? this.createDropdown() : null}
			</div>
		);
		let tooltipMessage = this.props.selectedEventDetails.isVirtual ? this.props.resources['PWS.MyAccount.GuestsTabGuestEmailAddressNoEditVirtualMessage'].replace('{0}', this.props.resources['PWS.Profile.CompanyName']) : this.props.resources['PWS.MyAccount.GuestsTabGuestEmailAddressNoEditPhysicalMessage'].replace('{0}', this.props.resources['PWS.Profile.CompanyName']);
		let guestof = this.props.guest.guestOf && this.props.guest.guestOf != null ? <div className="guest-of">{`${this.props.resources['PWS.MyAccount.GuestsTabGuestOfText']}: ${this.props.guest.guestOf}`}</div> : null;

		let optOut = this.props.guest.optOut ? <FAIcon name="ban" size={13} fill="#999" inline={true} tooltipDirection="top-right" tooltip={this.props.resources['PWS.MyAccount.GuestsTabGuestOptOutText']} /> : (this.props.guest.email != null ? <Mailto email={this.props.guest.email}><FAIcon name="envelope_o" size={13} fill="#999" inline={true} tooltipDirection="top-right" tooltip={this.props.guest.email} /></Mailto> : <div style={{width: 13, display: "inline-block"}}></div>);

		return (
			<div className="clearfix guest-item btn-group">
				{showHideActions}
				<div className="guest-name">
					{optOut}&nbsp;&nbsp;{this.props.guest.name}
					{guestof}
				</div>
				{this.displayStatus()}
				<Modal show={this.state.showEditModal} onHide={this.showEditModal.bind(this, false, "", "", "")}>
					<Modal.Header closeButton>
						<Modal.Title>{window.jenkon.resources["PWS.MyAccount.PartyDetailsEditPartyDetailsLabel"]}</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<div className="formSectionSubTitle input-50">{this.props.resources['PWS.MyAccount.GuestsTabGuestNameLabel']}</div>
						<div className="formSectionSubTitle input-50">{this.props.resources['PWS.MyAccount.GuestsEditLabelEmail']}</div>
						<TextField
							ref="GuestName_Edit"
							name="EditGuest_GuestName"
							label={this.props.resources['PWS.MyAccount.GuestsTabGuestNameLabel']}
							value={this.state.EditGuest_GuestName}
							handleChange={this.changeField.bind(this)}
							Rules={Rules.GuestName}
							classes="form-control input-50 input-bordered clearable"
						/>
						<TextField
							ref="EmailAddress_Edit"
							name="EditGuest_GuestEmailAddress"
							alwaysShowTooltip={!this.props.validGuestEmail_edit}
							tooltip={this.props.validGuestEmail_edit ? null : tooltipMessage}
							label={this.props.resources['PWS.MyAccount.GuestsTabGuestEmailAddressLabel']}
							value={this.state.EditGuest_GuestEmailAddress}
							handleChange={this.changeField.bind(this)}
							handleBlur={this.validateEmail.bind(this)}
							handleFocus={HostActions.resetValidGuestEmailEdit}
							Rules={Rules.EmailAddress}
							classes="form-control input-50 input-bordered clearable"
						/>
						<div className="spacer12"></div>
						<SelectField
							name="selectedFilter"
							title={this.props.resources['PWS.MyAccount.GuestsEditLabelRSVPStatus']}
							value={this.state.GuestStatusEdit}
							optionData={this.state.editStatusList}
							keys={Keys}
							showEmptyOption={false}
							handleChange={this.setStatus.bind(this)}
							Rules={Rules.Status}
						/>
						<div className="spacer12"></div>
					</Modal.Body>
					<Modal.Footer>
						<div className="required-field-legend"> = {this.props.resources["PWS.Globals.Required"]}</div>
						<button type="button" className="secondaryBtn medium customButton" onClick={this.showEditModal.bind(this, false)}>{this.props.resources["PWS.MyAccount.PartyDetailsEditPartyCancelLabel"]}</button>&nbsp;&nbsp;
						<button type="button" className={classnames("medium customButton", {disabledBtn: !this.state.editHasChanged, primaryBtn: this.state.editHasChanged })} disabled={!this.state.editHasChanged} onClick={this.updateGuest.bind(this)}>{this.props.resources["PWS.MyAccount.PartyDetailsEditPartySaveChangesLabel"]}</button>
					</Modal.Footer>
				</Modal>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/MyAccount/HostPortal/Tab_Guest_Grid_Item.js